<template>
    <newForm v-bind:title='$t("cartable_management.cartable_managment_title")' className="col-xs-12">
        <div class="row form-group">
            <div class="col-md-6">
                <label class="radio"><b>{{$t('cartable_management.tree')}}</b></label>
                <div class="radio">
                    <label><input v-model="isOpenCartablFolders" type="checkbox" value="false" @change="isOpenCartablFoldersChange">{{$t('cartable_management.expand_folders_by_default')}}</label>
                </div>
                <div class="radio">
                    <label><input v-model="expandStaffFolders" type="checkbox" value="false" @change="expandStaffFoldersChange">{{$t('cartable_management.tree_expanded')}}</label>
                </div>
                <div class="radio">
                    <label><input v-model="hideUserDefaultFolders" type="checkbox" value="false" @change="hideUserDefaultFoldersChange">{{$t('cartable_management.hide_default_user_folders')}}</label>
                </div>
            </div>
        </div>

        <hr />

        <div class="row form-group">
            <div class="col-md-6">
                <div class="form-group">
                    <label class="radio"><b>{{$t("cartable_management.cartable_date_setup")}}</b></label>
                    <label class="radio">
                        <input type="radio" name="rbtCartableDate" value="true" v-model="cartableDate" @change="cartableDateChange">
                        {{$t("cartable_management.exact")}}

                        ({{$t("cartable_management.exact_dsc")}})
                    </label>
                    <label class="radio">
                        <input type="radio" name="rbtCartableDate" value="false" v-model="cartableDate" @change="cartableDateChange">
                        {{$t("cartable_management.limited")}}

                        ({{$t("cartable_management.limited_dsc")}})
                    </label>
                </div>
            </div>
        </div>

        <hr />

        <div class="row form-group">
            <div id="ca-management" v-bind:class="colMd">
                <label class="radio">{{$t("cartable_management.select_person")}}</label>

                <div id="pacPrincipals"></div>
                <br />
                <br />
            </div>
            <div class="col-md-4">
                <div class="row form-group">
                    <div class="col-md-12">
                        <label class="radio">{{$t("cartable_management.dont_works")}}</label>
                        <input v-model="workingAlias" type="text" class="form-control" />
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12">
                        <label class="radio">{{$t("cartable_management.done_work")}}</label>
                        <input v-model="completedAlias" type="text" class="form-control" />
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12">
                        <label class="radio">{{$t("cartable_management.dont_send_request")}}</label>
                        <input v-model="draftAlias" type="text" class="form-control" />
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12">
                        <button class="btn btn-success"
                                v-on:click="saveFolderNames()" v-bind:disabled="disable!=0">
                            {{$t("save")}}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <hr />

        <div class="row form-group">
            <div class="col-md-12">
                <span>
                    {{$t("attention")}}<br />
                    {{$t("cartable_management.attention_message")}}
                </span>
            </div>
        </div>

    </newForm>
</template>
<script type="text/javascript">

    import NewForm from '../forms/newform/newForm.vue';
    import Loading from '../widgets/loading/loading.vue';

    export default {
        data() {
            return {
                direction: payload.currentLocale.IsRightToLeft,
                expandStaffFolders: payload.ExpandStaffTree,
                isOpenCartablFolders: payload.isOpenCartablFolders,
                hideUserDefaultFolders: payload.HideUserDefaultFolders,
                exactDateTime: false,
                noneExactDateTime: false,
                workingAlias: "",
                completedAlias: "",
                draftAlias: "",
                disable: 0,
                cartableDate: true,
                colMd: payload.currentLocale.IsRightToLeft ? "col-md-4" : "col-md-5"
            }
        },
        methods: {
            cartableDateChange() {

                var url = "api/folder/set-date-state?value=" + this.cartableDate;
                
                this.doAjaxRequest(
                    url,
                    {},
                    () => { },
                    () => { },
                    "PUT");
               
                payload.isExactDate = this.cartableDate;
            },
            expandStaffFoldersChange() {

                var url = "api/folder/tree-staff-expanded?expanded=" + this.expandStaffFolders;
                
                this.doAjaxRequest(
                    url,
                    {},
                    () => { },
                    () => { },
                    "PUT");

                payload.ExpandStaffTree = this.expandStaffFolders;
            },
            isOpenCartablFoldersChange() {
                var url = "api/folder/open-cartable-folders?isExpand=" + this.isOpenCartablFolders;

                this.doAjaxRequest(
                    url,
                    {},
                    () => { },
                    () => { },
                    "PUT");

                payload.isOpenCartablFolders = this.isOpenCartablFolders;
            },
            hideUserDefaultFoldersChange() {

                var url = "api/folder/tree-hide-user-folders?value=" + this.hideUserDefaultFolders;

                this.doAjaxRequest(
                    url,
                    {},
                    () => { },
                    () => { },
                    "PUT");

                payload.HideUserDefaultFolders = this.hideUserDefaultFolders;
            },
            saveFolderNames() {

                var $pacprincipals = $('#pacPrincipals');

                var principalIds = $pacprincipals.baseautocomplete("getSelectedIds");
                

                if (typeof principalIds === "undefined" || principalIds === null || principalIds.length == 0) {
                    alert(i18n.$t("messages.not_selected_principals"));
                    return;
                } else if (this.workingAlias.length === 0) {
                    alert(i18n.$t("messages.write_dont_work_folder_name"));
                    return;
                } else if (this.completedAlias.length === 0) {
                    alert(i18n.$t("messages.write_done_work_folder_name"));
                    return;
                } else if (this.draftAlias.length === 0) {
                    alert(i18n.$t("messages.write_dont_send_request_folder_name"));
                    return;
                }

                this.disable = 1;

                let data = {};

                data.Principals = principalIds;
                data.Working = this.workingAlias;
                data.Completed = this.completedAlias;
                data.Draft = this.draftAlias;

                var that = this;

                let callback = (result) => {

                    $pacprincipals.baseautocomplete("clearSelectedItems");

                    that.disable = 0;
                    that.workingAlias = "";
                    that.completedAlias = "";
                    that.draftAlias = "";

                    var params = {
                        text: this.$t('messages.sucsses_message'),
                        type: 'information',
                        layout: 'center',
                        timeout: 3000
                    };

                    noty(params);
                };

                this.doAjaxRequest(
                    "api/cartable-admin/save-folder-alias",
                    JSON.stringify(data),
                    callback,
                    () => {
                    },
                    'PUT');
            },
            loadFolderNames(principalId) {

                var that = this;

                var url = "api/cartable-admin/folder-alias/" + principalId;

                this.doAjaxRequest(
                    url,
                    {},
                    (data) => {
                        that.workingAlias = data.Working;
                        that.completedAlias = data.Completed;
                        that.draftAlias = data.Draft;
                    },
                    () => {
                        that.workingAlias = "";
                        that.completedAlias = "";
                        that.draftAlias = "";
                    });
            },
            doAjaxRequest(url, data, onSuccess, onFailure, method) {

                let ajaxConfig = {
                    url: url,
                    data: data,
                    dataType: "json",
                    contentType: "application/json;charset=utf-8"
                };
               
                ajaxConfig.beforeSend = (xhr) => {
                    xhr.setRequestHeader("__RequestVerificationToken", $("[name='__RequestVerificationToken']").val());
                };
                if (method) {
                    ajaxConfig.method = method;
                }
                $.ajax(ajaxConfig)
                    .done((result) => {
                        if (typeof onSuccess === 'function')
                            onSuccess(result);
                    }).error((error) => {
                        if (typeof onFailure === 'function') {

                            var response = null;

                            if (error.status == 400) {
                                response = JSON.parse(error.responseText);
                                onFailure(response);
                            }
                        }
                    });
            }
        },
        mounted() {

            var $pacprincipals = $('#pacPrincipals');

            var that = this;

            this.doAjaxRequest(
                "api/cartable-admin/load-data", {},
                (data) => {
                    that.cartableDate = data.DateState;

                    $pacprincipals.baseautocomplete({
                        source: data.Principals,
                        // iconPathList: ['dist/user.png', 'dist/group.png', 'dist/staff.png'],
                        FAiconList: ['far fa-user', 'far fa-users', 'far fa-users-class'],
                        select: function (evt, item) {

                            var principalIds = $pacprincipals.baseautocomplete("getSelectedIds");

                            if (principalIds === null || typeof principalIds === "undefined" || principalIds.length === 0) {
                                that.loadFolderNames(item.item.id);
                            } else {
                                that.workingAlias = "";
                                that.completedAlias = "";
                                that.draftAlias = "";
                            }
                        }
                    });

                });
        },
        created() {
        },
        components: {
            NewForm,
            Loading
        }
    }

</script>
